/**
 * Created by mykurisu on 2017/8/21.
 */
import React from 'react'
import {connect} from 'react-redux'
import {
    Page,
    WKError,
} from '../../components/index'
import {
    Header,
    Footer,
    ListTitle,
    LecturerListcurrent,
    LecturerListHistory,
    DefaultContent,
    LecturerInit,
} from '../../components/lecturerInvite/index'
import '../../css/page/LecturerInvitePage.css'


class LecturerInvitePage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            urlData: {
                type: this.props.routeParams.type,
                target_id: this.props.routeParams.target_id
            },
        };
        document.title = '嘉宾管理'
    }


    render(){
        const {urlData} = this.state;
        const {currentList, selectedList, error, lectureInfo} = this.props;

        if (error.showError) {
            return (
                <div style={{background: '#fff', width: '100%', height: '100vh'}}>
                    <WKError />
                </div>
            )
        }

        return (
            <Page className="wrap-lecturer-invite-page">
                <div className="lecturer-invite-container">

                    <LecturerInit urlData={urlData}/>

                    <Header targetName={lectureInfo.name}/>

                    {selectedList && selectedList.length > 0 &&
                    <ListTitle title={"当前嘉宾"} type={'now'}/>
                    }
                    <LecturerListcurrent />

                    {currentList && currentList.length > 0 &&
                    <ListTitle title={"历史嘉宾"} type={'history'}/>
                    }
                    <LecturerListHistory />
                    {!(currentList && currentList.length === 0 && selectedList && selectedList.length === 0) &&
                    <Footer urlData={urlData}/>
                    }

                    {currentList && currentList.length === 0 && selectedList && selectedList.length === 0 &&
                    <DefaultContent urlData={urlData}/>
                    }

                </div>
            </Page>
        )
    }
}


export default connect(state => ({
    lectureInfo: state.lecturerInvite.lectureInfo,
    currentList: state.lecturerInvite.currentList,
    selectedList: state.lecturerInvite.selectedList,
    error: state.error,
}))(LecturerInvitePage)


// WEBPACK FOOTER //
// ./src/pages/lecutrerInvite/LecturerInvitePage.js